import { OrganizationUnitCooperationSelection as OrganizationUnitCooperationSelectionType } from '../../../../../../types/Survey/Element'
import { OrganizationUnitCooperationSelection as OrganizationUnitCooperationSelectionAnswerType } from '../../../../../../types/Survey/Answer/Element'
import { Props } from '../types'
import Core from '../Core'
import List from './List'
import { sortUnits } from '../../../../../../utility'
import { OrganizationUnit } from '../../../../../../types/OrganizationUnit'

const OrganizationUnitCooperationSelection: React.FC<
  Props<OrganizationUnitCooperationSelectionType, OrganizationUnitCooperationSelectionAnswerType>
> = ({ survey, element, answer, answerElement, updateElement }) => {
  const toggle = (uuid: string) => () => {
    const isSelected = answerElement.organizationUnitPrioSelectionList.find((u) => u.organizationUnitUUID === uuid)
    if (isSelected) {
      updateElement({
        ...answerElement,
        organizationUnitPrioSelectionList: answerElement.organizationUnitPrioSelectionList.filter((sO) => sO.organizationUnitUUID !== uuid),
      })
    } else if (answerElement.organizationUnitPrioSelectionList.length + 1 <= element.maxMultipleChoice) {
      updateElement({
        ...answerElement,
        organizationUnitPrioSelectionList: [...answerElement.organizationUnitPrioSelectionList, { organizationUnitUUID: uuid, priority: 0 }],
      })
    }
  }

  const setPriority = (uuid: string) => (priority: number) => {
    updateElement({
      ...answerElement,
      organizationUnitPrioSelectionList: answerElement.organizationUnitPrioSelectionList.map((u) =>
        u.organizationUnitUUID === uuid ? { ...u, priority } : u,
      ),
    })
  }

  const isSelected = (uuid: string) => !!answerElement.organizationUnitPrioSelectionList.find((u) => u.organizationUnitUUID === uuid)

  const getPriority = (uuid: string) => {
    const selected = answerElement.organizationUnitPrioSelectionList.find((u) => u.organizationUnitUUID === uuid)
    return selected ? selected.priority : 0
  }

  const filterSelectableUnits = (unit: OrganizationUnit) => {
    if (!!answer && !!answer.organizationUnitUUID) {
      return unit.uuid !== answer.organizationUnitUUID
    }
    return true
  }

  return (
    <div>
      <Core element={element} />
      <div className="flex flex-row gap-2 justify-center mt-5">
        <List
          options={survey.context.organizationUnitList
            .filter(filterSelectableUnits)
            .sort(sortUnits)
            .map((unit) => ({
              uuid: unit.uuid,
              value: unit.name,
              selected: isSelected(unit.uuid),
              priority: getPriority(unit.uuid),
            }))}
          toggle={toggle}
          setPriority={setPriority}
        />
      </div>
    </div>
  )
}

export default OrganizationUnitCooperationSelection
